import mixins from "../../mixins";

const generateUID = mixins.generateUID.methods.generateUID;

export default {
  isEditMode: true,
  pageProperties: {
    "pages": [
      {
        "pageName": "home",
        "pageId": 1,
        "sections": [
          {
            "sectionId": "a0us1n",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                fieldId: "vas2fp",
                fieldType: "multi-campaign"
              }
            ]
          }
        ]
      },
      { // ProtexSummerCarrefour2022 campaign
        "pageName": "ProtexSummerCarrefour2022",
        "pageId": 28972,
        "isPublic": true,
        "sections": [
          {
            "sectionId": "orbg8s",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "fields": [
              {
                "fieldType": "refresh-token",
                "fieldId": "ij3433"
              },
              {
                fieldId: "dte-003",
                fieldType: "dataLayer-event",
                properties: {
                  eventName: "PageView",
                  fbEvent: "PageView"
                }
              },
              {
                "fieldType": "key-visual",
                "fieldId": "296eg1",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "styles": {
                    "margin": '2% 0 0 0',
                    "padding": '0'
                  },
                  "noContainer": false,
                  "addRow": true,
                  "desktopImageUrl": "/assets/campaigns/ProtexSummerCarrefour2022/key-visual.png",
                  "mobileImageUrl": "/assets/campaigns/ProtexSummerCarrefour2022/key-visual.png"
                }
              },
              {
                "fieldType": "participa",
                "fieldId": "acsh315",
                "properties": {
                  "grid": {
                    "columns": "12"
                  },
                  "color": "#024491",
                  "buttonClass": "btn-dark-blue-gradient",
                  "nextPage": "ProtexSummerCarrefour2022/InscrieBonul",
                  "campaign": "ProtexSummerCarrefour2022",
                  "steps": [
                    {
                      "title": "Pasul 1",
                      "text": "Cumpara produse Protex de min 18 Lei de la Carrefour",
                      "image": "select"
                    },
                    {
                      "title": "Pasul 2",
                      "text": "Incarca bonul fiscal",
                      "image": "receipt"
                    },
                    {
                      "title": "Pasul 3",
                      "text": "Inregistreaza-te",
                      "image": "register"
                    },
                    {
                      "title": "Pasul 4",
                      "text": "Castiga premii!",
                      "image": "reward"
                    }
                  ]
                }
              }
            ]
          }
        ]
      },
      { // Upload receipt
        "pageName": "ProtexSummerCarrefour2022/InscrieBonul",
        "pageId": 22345,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "step-counter",
                "fieldId": "tj4j49",
                "properties": {
                  "activeIndex": 1,
                  "colorSchema": "#024491",
                  "stepShadow": "#BBD0E9",
                  "startGradient": "#BBD0E9",
                  "endGradient": "#024491",
                  "completedGradient": "linear-gradient(265.49deg, #4D81BD 0.01%, #024491 99.55%), #ffffff",
                  "steps": [
                    {
                      "title": "Cumpara Protex",
                      "page": "PizBuinCarrefourJune2022/InscrieBonul"
                    },
                    {
                      "title": "Incarca bonul fiscal",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    },
                    {
                      "title": "Inregistreaza-te",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    },
                    {
                      "title": "Castiga premii!",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1 style='color= #141414;'>Incarca bonul fiscal/factura</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "La acest pas, te rugam sa incarci dovada achizitionarii participante Protex",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '24px;',
                    "color": "#2E2E2E"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un pdf al facturii",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '16px;',
                    "line-height": "26px;",
                    "color": "#474747"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#024491",
                        "fileUploadColor": "rgba(0, 0, 0, 0.5)",
                        "textColor": "#141414",
                        "borderColor": "#024491",
                        "buttonClass": "btn-dark-blue-gradient",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "ProtexSummerCarrefour2022/Inregistreaza"
                        },
                        "campaignId": "protex-summer-carrefour",
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "eraseColor": "#fff",
                        "eraseSize": 12,
                        "cropColor": "#024491",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Decupeaza",
                        "eraseTitle": "Acopera",
                        "dragTitle": "Deplaseaza imaginea",
                        "zoomInTitle": "Mareste",
                        "zoomOutTitle": "Micsoreaza",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#024491",
                        "backgroundColorBtn": "#024491"
                      }
                    },
                    {
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 7
                        },
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              "styles": {
                                "text-align": "left",
                                "background": "#FF6905"
                              },
                              "color": "#024491",
                              "textColor": "#141414",
                              "descriptionTextColor": "#E96161",
                              "descriptionText": "Nu se accepta bonuri sau facturi pliate/indoite sau scanate",
                              "receiptImage": "receipt18",
                              "steps": [
                                {
                                  "text": "Nume Retailer/ Magazin",
                                  "label": "A"
                                },
                                {
                                  "text": "Produsele care intra in promotie si pretul lor",
                                  "label": "B"
                                },
                                {
                                  "text": "Suma totala a bonului/facturii in LEI/RON",
                                  "label": "C"
                                },
                                {
                                  "text": "Nr bonului fiscal/facturii",
                                  "label": "D"
                                },
                                {
                                  "text": "Data si ora de pe bon sau de pe factura",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "bsbsd35",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "receipt-image-information"
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "40px"
            },
            "container": true,
            "buttonsWrap": true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm1",
                "properties": {
                  "grid": {
                    "columns": "0"
                  },
                  "addClass": "btn-link",
                  "text": "Inapoi",
                  "disabled": false,
                  "styles": {
                    "position": "absolute;",
                    "left": 0
                  },
                  "action": {
                    "fn": "goToPage",
                    "params": "ProtexSummerCarrefour2022"
                  }
                }
              },
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Continua",
                  "addClass": "btn-dark-blue-gradient",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Register form
        "pageName": "ProtexSummerCarrefour2022/Inregistreaza",
        "pageId": 634553232,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            "fields": [
              {
                "fieldType": "step-counter",
                "fieldId": "tj4j49",
                "properties": {
                  "activeIndex": 2,
                  "colorSchema": "#024491",
                  "stepShadow": "#BBD0E9",
                  "startGradient": "#BBD0E9",
                  "endGradient": "#024491",
                  "completedGradient": "linear-gradient(265.49deg, #4D81BD 0.01%, #024491 99.55%), #ffffff",
                  "steps": [
                    {
                      "title": "Cumpara Protex",
                      "page": "PizBuinCarrefourJune2022/InscrieBonul"
                    },
                    {
                      "title": "Incarca bonul fiscal",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    },
                    {
                      "title": "Inregistreaza-te",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    },
                    {
                      "title": "Castiga premii!",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "fckzg7",
                "properties": {
                  "text": "<h1>Formular de inscriere</h1>"
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "40px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--maxWidth": "545px",
                    "--backgroundColor": "#F4FCFE"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "ProtexSummerCarrefour2022/Multumim"
                  },
                  "endpoint": "/register",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#024491",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#024491",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#024491",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#024491",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "<b>Atentie!</b> In cazul introducerii unei adrese de e-mail gresite, daca esti declarat castigator, nu vei primi premiul castigat, conform Articolelor 4.3, 4.4, 8.7 si 8.8 din Regulamentul campaniei.",
                        "grid": {
                          "columns": "12",
                          "marginTop": "35px"
                        },
                        "classes": ['disclaimer'],
                        "styles": {
                          "color": "#2E2E2E !important"
                        }
                      }
                    },
                    {
                      "fieldId": "wgc3j7",
                      "fieldType": "checkbox",
                      "properties": {
                        "name": "terms",
                        "validation": {
                          "required": {
                            "allowFalse": false
                          }
                        },
                        "validationName": "Termenii si conditiile sunt necesare",
                        "grid": {
                          "columns": "12",
                          "paddingTop": "10px"
                        },
                        "styles": {
                          "margin-top": "30px",
                          "--color": "#2E2E2E",
                          "--border": "1px solid #FFC499",
                          "background-color": "border: #FFC499",
                          "--checkedCheckbox": "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox": "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        "label": `Confirm ca am peste 18 ani. Confirm <a href="/files/ProtexSummerCarrefour2022Regulament.pdf" target="_blank"><u>termenii si conditiile</u></a> si <a href="https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy" target="_blank"><u>politica de confidentialitate</u></a></div>.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "120px"
            },
            "container": true,
            "buttonsWrap": true,
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm1",
                "properties": {
                  "grid": {
                    "columns": "0"
                  },
                  "addClass": "btn-link",
                  "text": "Inapoi",
                  "disabled": false,
                  "styles": {
                    "position": "absolute;",
                    "left": 0
                  },
                  "action": {
                    "fn": "goToPage",
                    "params": "ProtexSummerCarrefour2022/InscrieBonul"
                  }
                }
              },
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "addClass": "btn-dark-blue-gradient",
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner form page
        "pageName": "ProtexSummerCarrefour2022/WinnerPage",
        "isPublic": true,
        "pageId": 634553,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "basb782",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "vasv24",
                properties: {
                  variables: [
                    {
                      query: "customerToken",
                      state: "customerToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "receiptToken",
                      state: "receiptToken"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1>Formular pentru Castigator</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Completeaza-ti adresa in formularul de mai jos pentru a-ti putea trimite premiul",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#2E2E2E"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "ci88zt",
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 4,
              "marginTop": "50px"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "form-component",
                "fieldId": "j765n4b",
                "properties": {
                  "styles": {
                    "margin": "0",
                    "justifyContent": "center",
                    "--backgroundColor": "#F4FCFE"
                  },
                  "grid": {
                    "alignItems": "center",
                    "columns": "0",
                    "justifyContent": "center"
                  },
                  "requires": [
                    "1"
                  ],
                  "successAction": {
                    "fn": "goToPage",
                    "params": "ProtexSummerCarrefour2022/WinnerThankYou"
                  },
                  "endpoint": "/winnerRegister",
                  "fields": [
                    {
                      "fieldId": "b4baqs",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "surname",
                        "autocomplete": "no",
                        "label": "Prenume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "alignItems": "center",
                          "justifyContent": "center",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#024491",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "gofije",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "name",
                        "autocomplete": "no",
                        "label": "Nume",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|onlyLetters",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#024491",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf9",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "email",
                        "label": "E-mail",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|email",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#024491",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "vake42c",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "mobile",
                        "label": "Numar de telefon",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "required|phoneNumber",
                        "grid": {
                          "columns": 12
                        },
                        "autocomplete": "nope",
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#024491",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "h7kzf8",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "address",
                        "label": "Adresa",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredAdress|adress",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#024491",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "ko3h1sz",
                      "fieldType": "paragraph",
                      "properties": {
                        "text": "*strada, numar, bloc, scara, apartament",
                        "grid": {
                          "columns": "12",
                          "marginTop": "20px;",
                          "marginBottom": "20px"
                        },
                        "classes": ['disclaimer'],
                        "styles": {
                          "color": "#2E2E2E !important"
                        }
                      }
                    }
                  ],
                  "extraFields": [
                    {
                      "fieldId": "bdsb632",
                      "fieldType": "select-input-county",
                      "properties": {
                        "name": "judet",
                        "label": "Judet",
                        "placeholder": "Judet",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredJudet",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "30px",
                          "border-color": "#024491",
                          "border-radius": "8px !important"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "bask257",
                      "fieldType": "select-input-city",
                      "properties": {
                        "name": "localitate",
                        "label": "Localitate",
                        "placeholder": "Localitate",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "requiredLocal",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#024491",
                          "border-radius": "8px !important"
                        },
                        "autocomplete": "nope"
                      }
                    },
                    {
                      "fieldId": "acasg235",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "postal",
                        "label": "Cod postal",
                        "placeholder": "",
                        "text": "",
                        "color": "#2E2E2E",
                        "validation": "integer|length:6",
                        "grid": {
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#024491",
                          "border-radius": "8px"
                        },
                        "autocomplete": "nope",
                        "disablePaste": true
                      }
                    },
                    {
                      "fieldId": "bsdy4362",
                      "fieldType": "text-input",
                      "properties": {
                        "name": "cnp",
                        "autocomplete": "no",
                        "label": "CNP",
                        "placeholder": "",
                        "text": "",
                        "validation": "required|integer|length:13",
                        "color": "#2E2E2E",
                        "grid": {
                          "alignItems": "center;",
                          "justifyContent": "center;",
                          "columns": 12
                        },
                        "styles": {
                          "margin-top": "50px",
                          "border-color": "#024491",
                          "border-radius": "8px"
                        }
                      }
                    },
                    {
                      "fieldId": "bsadbsd325",
                      "fieldType": "checkbox",
                      "properties": {
                        "name": "cnpConfirm",
                        "validation": {
                          "required": {
                            "allowFalse": false
                          }
                        },
                        "validationName": "terms",
                        "grid": {
                          "columns": "12",
                          "paddingTop": "10px"
                        },
                        "styles": {
                          "margin-top": "30px",
                          "--color": "#2E2E2E",
                          "--checkedCheckbox": "url(/assets/icons/form/checked_checkbox.svg)",
                          "--uncheckedCheckbox": "url(/assets/icons/form/unchecked_checkbox.svg)"
                        },
                        "label": `Declar ca acest CNP imi apartine, cunoscand faptul ca orice declaratie falsa este sanctionata conform legii penale romane.`
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "yh453gg4",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "130px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "TRIMITE",
                  "disabled": false,
                  "addClass": "btn-dark-blue-gradient",
                  "action": {
                    "fn": "sendForm",
                    "params": "j765n4b"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Winner thank you
        "pageName": "ProtexSummerCarrefour2022/WinnerThankYou",
        "pageId": 99830,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you-winner",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "ProtexSummerCarrefour2022",
                  "campaignName": "CAMPANIE PROTEX SUMMER CARREFOUR HYPER & ONLINE",
                  "haveActivator": false,
                  "textColor": "#141414",
                  'classNames': 'smoothies-helper'
                }
              }
            ]
          }
        ]
      },
      { // Receipt reupload
        "pageName": "ProtexSummerCarrefour2022/receipt-reupload",
        "isPublic": true,
        "pageId": 32,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1 style='color= #141414;'>Te rugam sa incarci din nou bonul fiscal/factura</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "Bonul fiscal/factura incarcat/a anterior ne este complet/a sau este ilizibl/a.",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '24px;',
                    "color": "#2E2E2E"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Te rugam sa faci o poza a intregului/intregii bon fiscal/facturi sau sa incarci un PDF al facturii",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '16px;',
                    "line-height": "30px;",
                    "color": "#2E2E2E"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "receipt-processor",
                      "fieldId": "klvakj",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca bonul fiscal/factura.</span>.<br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#024491",
                        "fileUploadColor": "rgba(0, 0, 0, 0.5)",
                        "textColor": "#141414",
                        "borderColor": "#024491",
                        "buttonClass": "btn-dark-blue-gradient",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "successAction": {
                          "fn": "goToPage",
                          "params": "ProtexSummerCarrefour2022/Multumesc"
                        },
                        "campaignId": "protex-summer-carrefour",
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "eraseColor": "#ffffff",
                        "eraseSize": 12,
                        "cropColor": "#024491",
                        "cropBackground": "rgba(0,0,0,0.6)",
                        "cropTitle": "Decupeaza",
                        "eraseTitle": "Acopera",
                        "dragTitle": "Deplaseaza imaginea",
                        "zoomInTitle": "Mareste",
                        "zoomOutTitle": "Micsoreaza",
                        "selectImageTitle": "Select an Image",
                        "selectAnotherTitle": "Select Another",
                        "controlsBackground": "#024491",
                        "backgroundColorBtn": "#024491",
                        "reUpload": true,
                        "tokenName": "token"
                      }
                    },
                    {
                      "fieldType": "empty-bucket",
                      "properties": {
                        "grid": {
                          "columns": 7
                        },
                        "fields": [
                          {
                            "fieldType": "receipt-information",
                            "fieldId": "5mq1p6",
                            "properties": {
                              "grid": {
                                "alignItems": "center",
                                "justifyContent": "center",
                                "columns": "12"
                              },
                              "styles": {
                                "text-align": "left"
                              },
                              "color": "#024491",
                              "textColor": "#141414",
                              "descriptionTextColor": "#E96161",
                              "descriptionText": "Nu se accepta bonuri sau facturi pliate/indoite sau scanate",
                              "receiptImage": "receipt18",
                              "steps": [
                                {
                                  "text": "Nume magazin",
                                  "label": "A"
                                },
                                {
                                  "text": "Produsele participante la promotie si pretul lor",
                                  "label": "B"
                                },
                                {
                                  "text": "Suma totala a bonului fiscal/facturii in LEI",
                                  "label": "C"
                                },
                                {
                                  "text": "Nr. bonului fiscal/facturii",
                                  "label": "D"
                                },
                                {
                                  "text": "Data si ora de pe bonul fiscal sau factura",
                                  "label": "E"
                                }
                              ]
                            }
                          }
                        ]
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "bsbsd35",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "receipt-image-information"
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "paddingTop": "60px",
              "paddingBottom": "40px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Trimite",
                  "addClass": "btn-dark-blue-gradient",
                  "shouldCheckCrop": true,
                  "requires": ["klvakj"],
                  "action": {
                    "fn": "sendReceipt",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Product reupload
        "pageName": "ProtexSummerCarrefour2022/product-reupload",
        "isPublic": true,
        "pageId": 1282452,
        "sections": [
          {
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "headerWrap": true,
            "sectionId": "fu30zq",
            "fields": [
              {
                "fieldType": "query-string-to-state",
                "fieldId": "uwxo2o1",
                properties: {
                  variables: [
                    {
                      query: "referenceNumber",
                      state: "formData"
                    }
                  ]
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "uwxo2o",
                "properties": {
                  "text": "<h1 style='color= #141414;'>Incarca o poza a produsului</h1>"
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basv352",
                "properties": {
                  "text": "Incarca o poza cu produsele participante in campanie",
                  "grid": {
                    "marginTop": "15px",
                    "marginBottom": "30px"
                  },
                  styles: {
                    "font-weight": '500;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '20px;',
                    "color": "#2E2E2E"
                  }
                }
              },
              {
                "fieldType": "paragraph",
                "fieldId": "basg325",
                "properties": {
                  "text": "Doar fisiere JPG, si PNG sunt acceptate. Fisierul poate avea maxim 16MB.",
                  "grid": {
                    "marginBottom": "40px"
                  },
                  styles: {
                    "font-weight": '400;',
                    "font-family": 'Plus Jakarta Sans;',
                    "font-size": '14px;',
                    "line-height": "20px;",
                    "color": "#2E2E2E"
                  }
                }
              }
            ]
          },
          {
            "sectionId": "dyx8uv",
            "grid": {
              "columns": 12,
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "empty-bucket",
                "properties": {
                  "grid": {
                    "columns": 0,
                    "justifyContent": "center",
                    "maxWidth": "1230px"
                  },
                  "fields": [
                    {
                      "fieldType": "product-upload",
                      "fieldId": "ase123v",
                      "properties": {
                        texts: {
                          choose: 'Selecteaza un fisier',
                          receiptUpload: '<span style="font-size:18px; font-weight: 500;font-family:Plus Jakarta Sans">Apasa aici pentru a incarca poza</span><br> Doar fisierele JPEG, PNG si PDF sunt acceptate.<br> Fisierul poate avea maxim 16 MB.',
                          wrongFormat: 'Acest format nu este suportat. Doar fisiere jpeg, png sau pdf sunt acceptate.',
                          fileSizeLimit: 'Fisierul este prea mare. Acesta nu poate avea mai mult de 16 MB.'
                        },
                        "colorSchema": "#024491",
                        "borderColor": "#024491",
                        "buttonClass": "btn-dark-blue-gradient",
                        "textColor": "#141414",
                        "grid": {
                          "columns": 5,
                          "alignItems": "center",
                          "justifyContent": "center"
                        },
                        "endpoint": "/uploadProductPhoto",
                        "successAction": {
                          "fn": "goToPage",
                          "params": "ProtexSummerCarrefour2022/Multumesc"
                        },
                        "phrases": [
                          "Chitanta dvs. este acum incarcata si procesata.",
                          "Chitanta va fi procesata automat. Aceasta poate dura un minut. Va rugam sa aveti rabdare.",
                          "Daca primiti un mesaj de eroare, luati o versiune mai buna a chitantei si incarcati-o din nou."
                        ],
                        "cornerDetectionPhrases": [
                          "Te rugam sa ajustezi dreptunghiul gri pentru a incadra bonul.",
                          "Te rugam sa potrivesti bonul in cadran.",
                          "Puteti sterge informatii private cu instrumentul de stergere."
                        ],
                        "reUpload": true
                      }
                    }
                  ]
                }
              }
            ]
          },
          {
            "sectionId": "hmgwhl",
            "grid": {
              "columns": 12,
              "display": "flex",
              "alignItems": "center",
              "position": "relative",
              "marginTop": "60px",
              "marginBottom": "30px"
            },
            "container": true,
            "styles": {
              'justify-content': 'center'
            },
            "fields": [
              {
                "fieldType": "button-component",
                "fieldId": "16tzm2",
                "properties": {
                  "grid": {
                    "columns": "0",
                    "alignItems": "center",
                    "justifyContent": "center"
                  },
                  "text": "Trimite",
                  "addClass": "btn-dark-blue-gradient",
                  "shouldCheckCrop": false,
                  "requires": ["ase123v"],
                  "action": {
                    "fn": "sendProductPhotos",
                    "params": ""
                  }
                }
              }
            ]
          }
        ]
      },
      { // Thank you
        "pageName": "ProtexSummerCarrefour2022/Multumim",
        "pageId": 99800,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "step-counter",
                "fieldId": "tj4j49",
                "properties": {
                  "activeIndex": 3,
                  "colorSchema": "#024491",
                  "stepShadow": "#BBD0E9",
                  "startGradient": "#BBD0E9",
                  "endGradient": "#024491",
                  "completedGradient": "linear-gradient(265.49deg, #4D81BD 0.01%, #024491 99.55%), #ffffff",
                  "steps": [
                    {
                      "title": "Cumpara Protex",
                      "page": "PizBuinCarrefourJune2022/InscrieBonul"
                    },
                    {
                      "title": "Incarca bonul fiscal",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    },
                    {
                      "title": "Inregistreaza-te",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    },
                    {
                      "title": "Castiga premii!",
                      "page": "PizBuinCarrefourJune2022/Inregistreaza"
                    }
                  ]
                }
              },
              {
                "fieldType": "thank-you",
                "fieldId": "gjd10",
                "properties": {
                  "campaign": "ProtexSummerCarrefour2022",
                  "campaignName": "CAMPANIE PROTEX SUMMER CARREFOUR HYPER & ONLINE",
                  "haveActivator": false,
                  "borderColor": "#024491",
                  "textColor": "#141414",
                  "referenceColor": "#024491",
                  "classNames": "smoothies-helper"
                }
              }
            ]
          }
        ]
      },
      { // Thank you after reupload
        "pageName": "ProtexSummerCarrefour2022/Multumesc",
        "pageId": 99801,
        "noContainer": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center"
            },
            "container": true,
            "fields": [
              {
                "fieldType": "thank-you",
                "fieldId": "gjd11",
                "properties": {
                  "campaign": "ProtexSummerCarrefour2022",
                  "campaignName": "CAMPANIE PROTEX SUMMER CARREFOUR HYPER & ONLINE",
                  "haveActivator": false,
                  "borderColor": "#024491",
                  "textColor": "#141414",
                  "referenceColor": "#024491",
                  "classNames": "smoothies-helper"
                }
              }
            ]
          }
        ]
      },
      { // Error page
        "pageName": "error-page",
        "pageId": 10424,
        isPublic: true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12
            },
            "container": true,
            fields: [
              {
                "fieldType": "error-page",
                "fieldId": "gjd10",
                "properties": {
                  "grid": {
                    "columns": "12"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Faq
        "pageName": "ProtexSummerCarrefour2022/IntrebariFrecvente",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#2E2E2E",
                  "title": "Intrebari frecvente",
                  "items": [
                    { // 1
                      title: `Ce condiții trebuie să îndeplinesc pentru a participa la CAMPANIA „PROTEX SUMMER CARREFOUR HYPER & ONLINE”?`,
                      text: `
                      <ul>
                          <li>Vârsta minimă: Trebuie să ai cel puțin 18 ani.</li>
                          <li>Domiciliul: Trebuie să ai domiciliul în România</li>
                          <li>Adresa de e-mail: Poți participa doar cu propria adresă de e-mail.</li>
                      </ul>
                      <div style="margin-top: 10px">Numărul de telefon: Trebuie să folosești un număr de telefon mobil din România</div>`
                    },
                    { // 2
                      title: `Cum pot participa la CAMPANIA „PROTEX SUMMER CARREFOUR HYPER & ONLINE”?`,
                      text: `Poți participa doar online, prin intermediul site-ului campaniei <a href="/ProtexSummerCarrefour2022" target="_blank">promocolgatepalmolive.ro</a>. Din păcate, nu este posibilă participarea prin poștă. Procesul poate fi descris după cum urmează:
                      <ul style="margin-top: 10px; margin-bottom: 10px">
                          <li>Achiziționează produse participante în valoare de cel puțin 18 lei;</li>
                          <li>Fotografiază și încarcă bonul fiscal fizic sau factura electronică;</li>
                          <li>Introdu adresa de e-mail și alte informații personale;</li>
                      </ul>
                      Doar în cazul solicitării ulterioare, trebuie să încarci o fotografie a părții posterioare a produsului tău, respectiv produselor tale Protex. (Trebuie să te asiguri că este vizibil codul de bare al produsului tău, respectiv produselor tale.) În mod suplimentar, bonul fiscal/factura trebuie să apară clar/ă și lizibil/ă pe fotografia cu produsul.
                      <ul style="margin-top: 10px;">                          
                          <li>Acceptă termenii de participare și protecția datelor.</li>
                      </ul>
                      <div style="margin-top: 10px">Notă: Nu este posibilă utilizarea unor adrese de e-mail diferite (conturi de utilizator) pentru aceeași
                      persoană.</div>`
                    },
                    { // 3
                      title: `Pe cine trebuie să contactez dacă am o întrebare privitoare la CAMPANIA „PROTEX SUMMER CARREFOUR HYPER & ONLINE”?`,
                      text: `Te rugăm să contactezi serviciul de relații clienți Protex la adresa <a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>`
                    },
                    { // 4
                      title: `Ce produse trebuie să cumpăr pentru a participa la CAMPANIA „PROTEX SUMMER CARREFOUR HYPER & ONLINE”?`,
                      text: `Produsele participante sunt urmatoarele:
                      <ul style="margin-top: 10px;">
                          <li>Gel de duș cu vitamina E Protex 500ml (8718951348592)</li>
                          <li>Gel de duș Protex Deep Clean 500ml (8718951348615)</li>
                          <li>Gel de duș Protex Fresh, 500 ml (8718951405684)</li>
                          <li>Săpun antibacterian Protex Ultra 90g (8693495033206)</li>
                          <li>Săpun Protex Fresh 90g (8693495033411)</li>
                          <li>Săpun Protex Cream 90g (8693495033329)</li>
                          <li>Săpun Protex Deo12 90g (8693495033381)</li>
                          <li>Săpun antibacterian herbal Protex 90g (8693495033237)</li>
                          <li>Săpun solid antibacterian Protex Deep Clean 90g (8718951302846)</li>
                          <li>Săpun antibacterian cu propolis Protex 90g (8693495033268)</li>
                          <li>Săpun antibacterian cu vitamina E Protex 90g (8693495046541)</li>
                          <li>Săpun antibacterian cu aloe Protex 90g (8693495033299)</li>
                          <li>Săpun lichid Antibacterian Ultra Protex 300ml (8693495051743)</li>
                          <li>Săpun lichid Fresh Protex 300ml (8693495051712)</li>
                          <li>Săpun lichid antibacterian cream Protex 300ml (8693495054355)</li>
                          <li>Săpun lichid Antibacterial Herbal Protex 300ml (8693495051682)</li>
                          <li>Săpun lichid Protex Ultra Doypack 500ml (8718951496880)</li>
                          <li>Săpun lichid Protex Fresh Doypack 500ml (8718951496910)</li>
                          <li>Săpun lichid antibacterian Protex Ultra 700ml (8718951372344)</li>
                          <li>Săpun lichid antibacterian Protex Fresh 700ml (8718951372320)</li>
                          <li>Săpun lichid antibacterian Protex Cream 700ml (8718951372634)</li>
                          <li>Săpun lichid antibacterian Protex Herbal 700ml (8718951372306)</li>
                          <li>Săpun lichid Charcoal Protex 300ml (8718951486829)</li>
                          <li>Gel de duș Protex Charcoal 500ml (8718951486843)</li>
                          <li>Săpun Protex Charcoal 90g (8718951458925)</li>
                          <li>Săpun lichid Protex Fresh Sticker Antibac 300ml (8693495051712)</li>
                          <li>Săpun lichid Protex Ultra Sticker Antibac 300ml (8693495051743)</li>
                      </ul>`
                    },
                    { // 5
                      title: `De unde pot cumpăra produsele participante la CAMPANIA „PROTEX SUMMER CARREFOUR HYPER & ONLINE”?`,
                      text: `Poți cumpăra toate produsele participante la campanie din Carrefour Hyper si magazinul online din România.`
                    },
                    { // 6
                      title: `Când pot participa la CAMPANIA „PROTEX SUMMER CARREFOUR HYPER & ONLINE”?`,
                      text: `Perioada de achiziție a produselor participante este cuprinsă între 11.08.2022 și, inclusiv, 11.09.2022.
                      Termenul-limită pentru trimiterea formularului de înregistrare online și încărcarea bonului
                      fiscal/facturii de achiziție este 11.09.2022.`
                    },
                    { // 7
                      title: `Cât de des pot participa la CAMPANIA „PROTEX SUMMER CARREFOUR HYPER & ONLINE”?`,
                      text: `Nu există limită de participare. Poți participa de câte ori dorești.`
                    },
                    { // 8
                      title: 'Când pot primi premiul?',
                      text: `După tragerea la sorți – în cazul în care ești declarat/ă câștigător/e –, vei fi imediat contactat/ă
                      pentru a furniza adresa de livrare. Vei primi premiul prin curier în termen de o lună după trimiterea
                      informațiilor suplimentare.`
                    },
                    { // 9
                      title: `Cât timp trebuie să păstrez bonul fiscal/factura?`,
                      text: `Trebuie să păstrezi bonul fiscal/factura până în momentul în care primești premiul.`
                    },
                    { // 10
                      title: 'Bonul meu fiscal conține produse participante Protex cu o valoare mai mare de 18 lei. Pot două sau mai multe persoane să folosească bonul fiscal/factura pentru participarea la tragerea la sorți?',
                      text: `În principiu, un bon fiscal/o factură poate participa o singură dată la CAMPANIA „PROTEX SUMMER CARREFOUR HYPER & ONLINE”. Produsele participante enumerate pe bonul
                        fiscal/factură nu pot fi luate în considerare, iar un produs participant nu poate fi transferat altei
                        persoane.`
                    },
                    { // 11
                      title: 'Nu am primit un e-mail de confirmare după terminarea procesului de înscriere. Ce trebuie să fac?',
                      text: `După ce te-ai înregistrat, vei primi un e-mail de confirmare cu un număr de referință format din 10
                      caractere alfanumerice. Te rugăm să verifici dosarul de SPAM și JUNK. Dacă nu ai primit un număr
                      de referință format din 10 caractere alfanumerice, te rugăm să participi din nou prin intermediul
                      site-ului pentru promoții <a href="/ProtexSummerCarrefour2022" target="_blank">promocolgatepalmolive.ro./ProtexSummerCarrefour2022</a>.`
                    },
                    { // 12
                      title: 'Am introdus o adresă de e-mail greșită. Există o modalitate de a afla dacă am câștigat?',
                      text: `Fiecare câștigător din campanie va fi anunțat pe pagina cu câștigători: <br />
                      <a href="/ProtexSummerCarrefour2022/castigatori" target="_blank">promocolgatepalmolive.ro/ProtexSummerCarrefour2022/castigatori/</a>`
                    },
                    { // 13
                      title: 'Când parcurg procesul de înscriere pentru tragerea la sorți, acesta se blochează la un moment dat. Ce trebuie să fac?',
                      text: `Dacă te încurci în timpul procesului de înscriere din motive tehnice, îți recomandăm – dacă este
                      posibil – să utilizezi un alt dispozitiv. De exemplu, treci de pe telefonul mobil pe calculator. Dacă
                      acest lucru nu rezolvă problema, poți încerca să folosești un alt browser (Google Chrome, Microsoft
                      Edge, Mozilla Firefox). Dacă sfaturile nu te ajută, te rugăm să trimiți un e-mail departamentului
                      nostru de suport: <a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>.  Te rugăm să furnizezi o descriere precisă a
                      problemei în e-mailul tău – o captură de ecran cu pasul la care te blochezi este perfectă. Alte
                      informații utile sunt dispozitivul tău, sistemul de operare și browserul pe care le folosești. Echipa
                      noastră de suport se va strădui să te ajute.`
                    },
                    { // 14
                      title: 'Cum îmi pot da seama dacă am reușit să încarc cu succes bonul fiscal/factura?',
                      text: `După ce încarci bonul fiscal/factura, introduci informațiile personale, va apărea un mesaj pe ecran
                      care confirmă înscrierea participării tale și îți afișează numărul personal de referință. Vei primi cu
                      promptitudine și un e-mail de confirmare sau respingere a participării pe adresa furnizată.`
                    },
                    { // 15
                      title: 'Cât timp este disponibil departamentul de suport?',
                      text: `Echipa noastră de suport este disponibilă de la începutul campaniei timp de 6 săptămâni după
                      expirarea datei de înregistrare. După 23.10.2022, datele tale vor fi șterse, departamentul de suport
                      va fi închis, iar întrebările tale nu vor mai fi tratate.`
                    },
                    { // 16
                      title: 'Bonul fiscal/factura mi-a fost respins/ă deoarece nu sunt lizibile toate informațiile. Ce informații trebuie să fie lizibile?',
                      text: `Magazinul, produsele participante Protex, prețul de achiziție al produselor Protex, valoarea
                      totală a bonului fiscal/facturii, numărul bonului fiscal/facturii, TVA-ul, orice reduceri care pot fi
                      aplicate, precum și ora și data.`
                    },
                    { // 17
                      title: 'De ce mi se solicită să încarc o fotografie cu produsele?',
                      text: `Poate fi din cauza faptului că bonul fiscal/factura nu conține denumirea completă a produselor
                        achiziționate.
                        În partea de jos a e-mailului de respingere, vei găsi un buton pentru a încărca fotografia cu
                        codurile de bare ale produselor. Dă clic pe buton și vei fi redirecționat/ă automat către încărcarea
                        din nou a fotografiei cu produsele. Te rugăm să realizezi o fotografie nouă a produselor și s-o încarci
                        din nou în termen de 72 de ore. Reține că butonul nu mai este funcțional după 72 de ore.
                        Dacă participarea ta este respinsă din nou, te rugăm să ne contactezi prin intermediul adresei de
                        e-mail de suport, care poate fi găsită și în e-mailul de respingere (<a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>).`
                    },
                    { // 18
                      title: 'De ce mi-a fost respinsă participarea, deși am cumpărat produsele corecte?',
                      text: `De exemplu, poate fi din cauza unei erori tehnice sau a faptului că bonul fiscal/factura nu este
                      suficient de lizibil/ă sau este supraexpus/ă. O altă cauză poate consta în faptul că ai încărcat în
                      mod accidental o factură proformă sau o comandă.
                      În partea de jos a e-mailului de respingere, vei găsi un buton pentru a încărca bonul fiscal/factura
                      din nou. Dă clic pe buton și vei fi redirecționat/ă automat către încărcarea din nou a bonului
                      fiscal/facturii. Te rugăm să realizezi o fotografie nouă a bonului fiscal/facturii și s-o încarci din nou în
                      termen de 72 de ore. Reține că butonul nu mai este funcțional după 72 de ore.
                      Dacă participarea ta este respinsă din nou, te rugăm să ne contactezi prin intermediul adresei de
                      e-mail de suport, care poate fi găsită și în e-mailul de respingere  (<a href="mailto:suport@promocolgatepalmolive.ro">suport@promocolgatepalmolive.ro</a>).`
                    },
                    { // 19
                      title: 'Bonul meu fiscal/factura nu a fost acceptat/ă sau chiar a fost marcat/ă ca fals/ă. Cum este posibil așa ceva?',
                      text: `În cazul în care bonul fiscal/factura este prea neclar/ă, prea întunecat/ă sau supraexpus/ă astfel
                      încât informațiile nu mai pot fi lizibile, există posibilitatea să primești un e-mail de respingere, în care
                      bonul fiscal/factura este descris/ă drept un fals sau ești rugat/ă să furnizezi o fotografie mai bună cu <b>Incarca bonul tau fiscal/factura</b>. Ajută-ne să îți acceptăm participarea rapid și fără complicații,
                      încărcând o fotografie de bună calitate (nu o scanare!) a bonului tău fiscal/facturii, care
                      demonstrează că ai un bon fiscal/o factură original/ă și în care sunt lizibile toate informațiile
                      necesare. Economisește mult timp și neplăceri atât pentru tine, cât și pentru noi.`
                    },
                    { // 20
                      title: 'Pot trimite bonul fiscal/factura și prin e-mail?',
                      text: `Ne pare rău să te informăm că nu este posibil să sari peste procesul de încărcare și să ne trimiți
                      bonul fiscal/factura prin e-mail. Echipa noastră de suport te poate ajuta doar în cazul în care poți
                      furniza numărul tău de referință, care poate fi găsit în e-mailul de confirmare sau respingere. În
                      cazul în care nu ai primit un asemenea e-mail, trebuie să repeți din nou procesul de înregistrare.`
                    },
                    { // 21
                      title: 'Ce se întâmplă cu informațiile pe care le-am introdus pe site-ul promoției?',
                      text: `Datele tale personale sunt prelucrate în scopul organizării și desfășurării Campaniei, pentru a-ți
                      putea permite participarea la aceasta și, în cazul în care ai fost declarat câștigător/e, pentru a-ți
                      acorda premiul. Prelucrarea este necesară pentru executarea contractului la care ești parte, și
                      anume regulamentul Campaniei cu care ești de acord în momentul înscrierii.`
                    },
                    { // 22
                      title: 'Am o întrebare generală despre Protex. Pe cine pot contacta?',
                      text: `Dacă ai nevoie de informații suplimentare privitoare la produsele noastre sau dacă ai orice alte
                      întrebări, ne poți contacta prin intermediul linkului de mai jos: <b><a href="https://www.colgatepalmolive.ro/contact-us" target="_blank">https://www.colgatepalmolive.ro/contact-us</a>.</b>`
                    }
                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      },
      { // Castigatori
        "pageName": "ProtexSummerCarrefour2022/castigatori",
        "isPublic": true,
        "sections": [
          {
            "grid": {
              "alignItems": "center",
              "justifyContent": "center",
              "columns": 12,
              "marginBottom": "50px"
            },
            "fields": [
              {
                "fieldType": "text-list",
                "fieldId": "a6prst",
                "properties": {
                  "colorSchema": "#000000",
                  "title": "Castigatori",
                  "ordered": false,
                  "items": [
                    {
                      title: `Oglinda de baie cu led si touch:`,
                      text: `
                      <ul>
                      <li>Giurca Aurica</li>
                      <li>Blaga Delia Alina</li>
                      <li>Andrei Alexandra</li>
                      </ul>`
                    },
                    {
                      title: `Voucher Carrefour:`,
                      text: `
                      <ul>
                        <li>Stanescu Meriem</li>
                        <li>Cristea	Lavinia</li>
                        <li>Strinoiu Dragos Costinel</li>
                        <li>Gheorghiu Mihaela-Jeni</li>
                        <li>Tamas Sandor Janos</li>
                        <li>Baescu Elena Otilia</li>
                        <li>Tatoiu Simona Ana</li>
                        <li>Necula Georgeta Diana</li>
                        <li>Galmeanu Alexandra Lavinia</li>
                        <li>Popa Stoican Felicia</li>
                        <li>Baescu Ionut Cosmin</li>
                        <li>Fuduli George</li>
                        <li>Georgescu Iulian Florin</li>
                        <li>Mitu Mioara</li>
                        <li>Baciu Isabela</li>
                        <li>Nicolae	Marius Ionuț</li>
                        <li>Irimia Marius</li>
                        <li>Dumitrache Ion</li>
                        <li>Colcea Iulian</li>
                        <li>Cojocaru Mihaela-Lavinia</li>
                        <li>Popescu	Alexandru</li>
                        <li>Popescu	Cornelia</li>
                        <li>Stoica Maria Anisoara</li>
                        <li>Pascalin Danut</li>
                        <li>Neculcea Mariana</li>
                        <li>Ionescu	Octavian</li>
                        <li>Iulian Neculcea ionut</li>
                        <li>Pleșa Andreea</li>
                        <li>Tirculete Rodica</li>
                        <li>Dumitrov Adriana</li>
                        <li>Dobroiu Camelia</li>
                        <li>Baciu Razvan Valentin</li>
                        <li>Oprea Aurelian</li>
                        <li>Blaga Lucian Ion</li>
                        <li>Ivan Mihaela</li>
                        <li>Geambasu Luminita</li>
                        <li>Osman Eda</li>
                        <li>Fratila Ecaterina</li>
                        <li>Carianopol Oana</li>
                        <li>Ghezea Doina</li>
                      </ul>`
                    }
                  ],
                  "grid": {
                    "alignItems": "center",
                    "justifyContent": "center",
                    "columns": "8"
                  }
                }
              }
            ]
          }
        ]
      }
    ],
    "header": {
      "fieldType": "navbar",
      "fieldId": "cbx34t",
      "properties": {
        "dataLayer": {
          "GTM": {
            "Sitelocale": "ro-ro",
            "SiteTouchpoint": "",
            "SiteCountry": "RO",
            "SiteBrand": "",
            "SiteLanguage": "RO",
            "SitePlatform": "",
            "SiteEnvironment": "Prod",
            "SiteHost": "CTL",
            "SiteTechnicalAgency": "Justsnap",
            "SiteStatus": "Live",
            "GoogleAnalyticsLocal": "UA-15274544-47",
            "GoogleAnalyticsBrand": "",
            "GoogleAnalyticsSiteSpeedSampleRate": "high",
            "GoogleAnalyticsAllowLinker": "true",
            "GoogleAnalyticsLinkerDomains": "",
            "GoogleAnalyticsEnableOptimizely": "false",
            "GoogleAnalyticsConsentRequired": "true",
            "GoogleAnalyticsOptimizeContainerID": "",
            "GoogleAnalyticsReportingView": "",
            "GoogleReCaptcha": "true",
            "SiteLocalContainer": "",
            "FacebookRemarketingID": "270266680523196",
            "ConsentOverlay": "OneTrust",
            "ConsentOverlayID": "htmllang/7bfbeeed-fe9a-477f-99c7-84ca45614eb3-test",
            "SitePrivacyProtection": "GDPR"
          },
          "GTM_CODE": "GTM-TG4C5LV"
        },
        // "neustar": {
        //   "url": "https://aa.agkn.com/adscores/g.js?sid=9212300878"
        // },
        // "facebookPixel": {
        //   init: "270266680523196"
        // },
        "title": "",
        "color": "#FAF6EE",
        "grid": {
          "columns": 12
        },
        "logo": {
          "imageSource": "/assets/logo.svg",
          "width": 345,
          "alternateText": "Brand Logo",
          "paddingTop": "30px"
        },
        "fields": [
          {
            "fieldId": "ikz8vc",
            "fieldType": "anchor",
            "properties": {
              "text": "Regulament",
              "url": "/files/ProtexSummerCarrefour2022Regulament.pdf",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          },
          {
            "fieldId": "slnmdk",
            "fieldType": "anchor",
            "properties": {
              "text": "Intrebari frecvente",
              "url": "/ProtexSummerCarrefour2022/IntrebariFrecvente",
              "target": "_blank",
              "cssClass": "nav-link",
              "styles": {
                "color": "#050E23",
                "fontSize": "18px",
                "fontWeight": "400"
              }
            }
          }
        ],
        "showLine": false,
        "meta": [
          { "name": "title", "content": "Protex" },
          {
            "name": "description",
            "content": `Protex`
          },
          {
            "name": "keywords",
            "content": `Protex`
          }
        ]
      }
    },
    "footer": {
      "fieldType": "footer-component",
      "fieldId": "4tfbzz",
      "properties": {
        "links": [
          { "name": "", "link": "" }
        ],
        "supportLinks": [
          { "name": "Confidentialitate", "link": "https://www.jnjconsumer.ro/politica-confidentialitate" }
        ],
        "styles": {
          "color": "#000"
        },
        "fields": [
          {
            "fieldId": "ikz8vc1",
            "fieldType": "anchor",
            "properties": {
              "text": "Termeni si conditii",
              "url": "/files/ProtexSummerCarrefour2022Regulament.pdf",
              "target": "_blank",
              "styles": {
                "color": "#40454A"
              }
            }
          },
          {
            "fieldId": "slnmdk2",
            "fieldType": "anchor",
            "properties": {
              "text": " Politica de confidentialitate",
              "url": "https://www.colgatepalmolive.ro/legal-privacy-policy/privacy-policy",
              "target": "_blank",
              "styles": {
                "color": "#40454A"
              }
            }
          }
        ]
      }
    },
    "campaignId": "protex-summer-carrefour",
    "url": "https://promocolgatepalmolive.ro/",
    "name": "ProtexSummerCarrefour2022"
  },
  pageBuilder: {
    selectedField: {
      sectionId: '',
      fieldId: generateUID()
    }
  },
  componentStatus: {},
  modal: {
    type: 'error',
    message: 'An error has occurred',
    isActive: false
  },
  customerToken: '',
  receiptToken: '',
  receiptImage: '',
  campaignId: 'protex-summer-carrefour',
  formData: new FormData(),
  campaignStartDate: "2022-08-11",
  campaignEndDate: "2022-09-11",
  showNavLinks: false,
  excludedPages: ['home'],
  cities: []
}
